/* eslint-disable max-len */
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SizeGuideIcon = function SizeGuideIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    enableBackground: "new 0 0 90 90",
    viewBox: "0 0 90 90",
    role: "presentation",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Size Guide Icon"
    }), /*#__PURE__*/_jsxs("g", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.93",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m79.7 19.2-9.7 9.7c-.6.6-1.5.6-2.1 0-.9-.9-2.6-.3-2.6 1v21.3c0 .8-.7 1.5-1.5 1.5h-37.6c-.8 0-1.5-.7-1.5-1.5v-21.2c0-1.3-1.6-2-2.5-1-.6.6-1.5.6-2.1 0l-9.7-9.7c-.6-.6-.6-1.5 0-2.1l13.9-14.1c.3-.3.7-.4 1-.4h10.1c.7 0 1.3.5 1.5 1.2.7 3.9 4.1 6.8 8.2 6.8s7.5-2.9 8.2-6.8c.1-.7.7-1.2 1.5-1.2h9.8c.4 0 .8.2 1.1.4l13.9 13.9c.6.7.6 1.6.1 2.2z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m45 76.5 2.2 8.7c.3 1.2 1.5 2.1 2.7 2.1h17.3c1.8 0 3.2-1.7 2.8-3.4l-4.8-21.9c-.3-1.3-1.4-2.2-2.8-2.2h-34.8c-1.3 0-2.5.9-2.8 2.2l-4.8 21.9c-.4 1.8 1 3.4 2.8 3.4h17.2c1.3 0 2.4-.9 2.7-2.1z"
      })]
    })]
  });
};

export default /*#__PURE__*/memo(SizeGuideIcon);